import React from 'react';
import { Button, Typography } from 'antd';

const { Text } = Typography;

const PolyuSSO = () => {
  const url = process.env.REACT_APP_POLYUSSO_AUTH_URL;
  return (
    <>
      <div style={{ marginBottom: '40px' }}>
        <Text type="secondary">
          Login with your polyu net ID & net password
        </Text>
      </div>
      <div>
        <Button
          type="primary"
          block
          href={url}
          // size="large"
          shape="round"
          style={{ marginBottom: '24px' }}
        >
          Login with PolyU SSO
        </Button>
      </div>
    </>
  );
};

export default PolyuSSO;
